import { color, font, query, space } from '@design/templateFns';
import styled from 'styled-components';

export const ScreenDiv = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 1000;
`;

export const HeaderWrapper = styled.div<{ $isModalOpen: boolean }>`
  overflow: initial;
  position: relative;
  z-index: ${({ $isModalOpen }) => ($isModalOpen ? '200' : '99')};
  padding-bottom: ${space('lg')};
  @media screen and (${query.atLeast('tablet')}) {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  @media screen and (${query.atLeast('desktop')}) {
    padding-bottom: ${space('x5')};
  }
`;

export const ContactWrapper = styled.div`
  z-index: 9;
  @media screen and (${query.below('tablet')}) {
    position: fixed;
    bottom: 0;
    left: 0;
    display: grid;
    grid-template-columns: 1fr 109px;
    width: 100%;
    height: 45px;
  }
`;

export const ShareContainer = styled.div`
  position: relative;
  display: inline-block;
  z-index: 1001;
`;

export const DropDown = styled.div`
  position: absolute;
  background: #ffffff;
  box-shadow: 2px 4px 15px rgba(0, 0, 0, 0.05);
  border-radius: 0px 0px 4px 4px;
  width: 192px;
  z-index: 99;

  a {
    ${font('body-md-light')};
    color: black;
    padding: 7px 10px 10px 16px;
    text-decoration: none;
    display: block;

    &:hover {
      background: #f4f4f4;
    }
  }
`;

export const MobileShare = styled.div`
  z-index: 1000;
  background-color: ${color('fg')};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  > a {
    > span {
      color: ${color('gray3')};
      > span {
        display: none;
      }
    }
  }
  @media screen and (${query.atLeast('tablet')}) {
    display: none;
  }
`;

export const MobileDropDown = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;

  background: #ffffff;
  box-shadow: 0px 1px 41px 0px rgba(0, 0, 0, 0.1);
  border-radius: 0px 0px 4px 4px;
  width: 100%;
  z-index: 1001;

  a {
    ${font('subhead-xs')};
    color: #757575 !important;
    color: black;
    padding: 11px;
    text-decoration: none;
    display: block;
    text-align: center;
    border-top: 0.5px #d3d3d3 solid;

    &:hover {
      background: #f4f4f4;
    }
  }

  @media screen and (${query.atLeast('tablet')}) {
    width: 192px;
  }
`;

export const MobileIconButtonsWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  gap: 1px;
  background-color: ${color('gray3')};
`;
export const MobileShareWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 11px;
  text-align: center;
  ${font('body-sm')};
  color: ${color('fg')};
`;
export const ShareLable = styled.div``;
export const ShareCloseIcon = styled.div`
  position: absolute;
  right: 11px;
  top: 11px;
`;

export const MediaContainer = styled.div`
  section {
    padding-top: ${space('xl')};
    padding-bottom: ${space('x8')};
    @media screen and (${query.below('tablet')}) {
      padding: 0;
    }
  }
`;

export const MobileButtonWrapper = styled.div<{ $isFavorite?: boolean }>`
  background-color: ${color('fg')};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  > a,
  > button {
    margin: 0;
    svg path {
      color: ${color('gray3')};
      fill: transparent;
    }
    &.is-fav {
      svg path {
        fill: ${({ $isFavorite }) => ($isFavorite ? color('gray3') : 'transparent')};
      }
    }
  }
  @media screen and (${query.atLeast('tablet')}) {
    display: none;
  }
`;

export const ButtonMobile = styled.div`
  a {
    width: auto;

    @media screen and (${query.below('tablet')}) {
      padding: 12px 20px;
    }
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  @media screen and (${query.below('tablet')}) {
    flex-direction: column;
    align-items: start;
  }
`;

export const Bar = styled.div`
  width: 1px;
  height: 56px;
  background-color: ${color('cta')};
  display: none;

  @media screen and (${query.atLeast('tablet')}) {
    margin: 0 ${space('xl')};
    ${space('md')};
    display: inline;
  }

  @media screen and (${query.atLeast('desktop')}) {
    margin: auto ${space('x6')};
    display: inline;
  }
`;

export const Header = styled.div`
  ${font('headline-xxs')};
  margin: 0;
  padding: 0;

  @media screen and (${query.atLeast('desktop')}) {
    ${font('headline-sm')};
  }
`;

export const PricedFromText = styled.div`
  ${font('body-sm-light')};

  @media screen and (${query.atLeast('desktop')}) {
    ${font('body-md-light')};
  }
`;

export const Address = styled.div`
  ${font('body-sm-light')};

  @media screen and (${query.atLeast('desktop')}) {
    ${font('body-md-light')};
  }
`;

export const AddressWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

export const ShareWrapper = styled.div`
  display: none;
  color: ${color('gray4')};
  @media screen and (${query.atLeast('tablet')}) {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: ${space('lg')};
  }
`;

export const SaveButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: ${space('sm')};
`;

export const StyledFavoriteButtonText = styled.div`
  color: ${color('gray4')};
  ${font('subhead-sm')};
`;
